import { useTranslation } from 'react-i18next'
import { TextField } from '@carsys/form'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import { FieldArray, useFormikContext } from 'formik'
import { IFormValues } from './types'
import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'

export const CatalogFieldsQuickNavigateToProductGroup = () => {
  const { t } = useTranslation()
  return (
    <>
      <Typography variant='h4' mb={2}>
        {t('wholesaler-catalog.config-quick-navigation')}
      </Typography>
      <Box>
        <QuickNavToProductGroupUUIDSArrayField />
      </Box>
    </>
  )
}

const QuickNavToProductGroupUUIDSArrayField = () => {
  const name = 'QuickNavToProductGroupUUIDS'
  const { values } = useFormikContext<IFormValues>()
  const { t } = useTranslation()

  return (
    <Box>
      <FieldArray name={name}>
        {({ remove, push }) => (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
              <Typography variant='h6'>{t('wholesaler-catalog.ProductGroupForCatalogUUIDS')}</Typography>
              <IconButton onClick={() => push({ TreeUUID: '' })} size='large'>
                <AddIcon />
              </IconButton>
            </Box>
            {(values[name] || []).map((_, index) => (
              <Box key={`${name}[${index}]`} sx={{ display: 'flex' }}>
                <TextField name={`${name}[${index}].TreeUUID`} label={t('wholesaler-catalog.ProductGroupForCatalogUUID')} />
                <IconButton sx={{ paddingTop: 0, paddingBottom: 0 }} onClick={() => remove(index)} size='large'>
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}
          </>
        )}
      </FieldArray>
    </Box>
  )
}
